module.exports = __webpack_public_path__ + "static/media/gesture-scroll.6d972a9e.svg";